module.exports = __webpack_public_path__ + "img/img21.7e6e451.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/img21.png
// module id = 366
// module chunks = 0